<template>
    <div class="achievements">
      <el-card>
        <div class="title">{{ $t('chatai.chatai', { msg: 'chatai.chatai' }) }}</div>
        <div class="content">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('chatai.chatroom', { msg: 'chatai.chatroom' })" name="first">
              <div class="chat">
                <!-- 聊天界面内容 -->
                <el-card class="chat-card">

                <div class="chat-messages">
                    <div v-for="message in messages" :key="message.id" :class="['message', message.sender === 'me' ? 'my-message' : 'their-message']">
                    <div class="message-content">{{ message.content }}</div>
                    </div>
                </div>
                
                </el-card>
              </div>
              <!-- <el-input
                v-model="inputMessage"
                placeholder="请输入消息"
                clearable
              
              ></el-input> -->

              <el-input
                    v-model="newMessage"
                    :placeholder="$t('chatai.inputchat', { msg: 'chatai.inputchat' })"
                    @keyup.enter="sendMessage"
                    class="message-input"
                >
                    <el-button  @click="sendMessage">Send</el-button>
                </el-input>
            </el-tab-pane>

            <el-tab-pane :label="$t('chatai.fqa', { msg: 'chatai.fqa' })" name="second">
              <div class="faq">
                <!-- 常见问题解答内容 -->
                <el-collapse v-model="activeNameqw" accordion>
              <el-collapse-item title="一致性 Consistency" name="1">
                <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
                <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
              </el-collapse-item>
              <el-collapse-item title="反馈 Feedback" name="2">
                <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
                <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
              </el-collapse-item>
              <el-collapse-item title="效率 Efficiency" name="3">
                <div>简化流程：设计简洁直观的操作流程；</div>
                <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
                <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
              </el-collapse-item>
              <el-collapse-item title="可控 Controllability" name="4">
                <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
                <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
              </el-collapse-item>
            </el-collapse>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
    </div>
  </template>
   
  <script>
  import axios from 'axios';

  export default {
    data() {
      return {
        activeName: 'first',
        messages: [
        { id: 1, content: this.$t('chatai.q1', { msg: 'chatai.q1' }), sender: 'me' },
        { id: 2, content: this.$t('chatai.a1', { msg: 'chatai.a1' }), sender: 'other' },
      ],
      newMessage: '',
      activeNamqw: '1'

      };
    },

    methods: {
    sendMessage() {
      if (this.newMessage.trim() !== '') {
        const messageContent = this.newMessage.trim();
        this.messages.push({ id: Date.now(), content: this.newMessage, sender: 'me' });
        this.newMessage = '';
        this.scrollToBottom();
      // axios.post('http://localhost:8088/ai/chat?msg='+messageContent,{ timeout: 60000 })
      axios.post('http://42.192.168.164:8088/ai/chat?msg='+messageContent,{ timeout: 60000 })
        .then(response=>{  
        this.messages.push({ id: Date.now(), content: response.data, sender: 'other' });
        this.scrollToBottom();
        })
        .catch(error => {
        if (error.code === 'ECONNABORTED') {
          console.error('Request timeout:', error);
          this.messages.push({ id: Date.now(), content: 'Error: Request timeout', sender: 'other' });
        } else {
          console.error('Request error:', error);
          this.messages.push({ id: Date.now(), content: 'Error: Unable to get response', sender: 'other' });
        }
        this.scrollToBottom();
      });
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatMessages = this.$el.querySelector('.chat-messages');
        chatMessages.scrollTop = chatMessages.scrollHeight;
      });
    }
  }
  }
  </script>
   
  <style scoped>
  .achievements {
    margin: 20px;
  }
   
  .title {
    font-size: 18px;
    font-weight: bold;
  }
   
  .content {
    margin-top: 20px;
  }
   
  .chat {
    height: 500px;
    background-color: #f5f5f5;
  }
   
  .faq {
    height: 300px;
    background-color: #f5f5f5;
  }
/* ai对答 */
.chat-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  background-color: #f5f5f5;
}

.chat-card {
  width: 1500px;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  overflow: auto; /* 确保内容区域支持滚动 */
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #fff;
}

.message {
  display: flex;
  padding: 5px 10px;
  margin: 5px 0;
  border-radius: 4px;
}

.my-message {
  justify-content: flex-end;
  background-color: #e1f5fe;
}

.their-message {
  justify-content: flex-start;
  background-color: #f1f1f1;
}

.message-content {
  max-width: 70%;
  word-wrap: break-word;
}

.message-input {
  border-top: 1px solid #ebeef5;
}
/* ai对答 */

  </style>